<template>
    <div>
        <v-layout row wrap>
            <v-flex xs12 sm6 md4 my-1 v-for="item in items" :key="item.id">
                <v-card
                class="elevation-5"
                >
                    <v-img
                    :src="item.imgThumbnailUrl"
                    aspect-ratio="2.00"
                    class="ma-2"
                    >
                        <v-layout column fill-height class=" ">
                            <v-spacer></v-spacer>
                            <v-flex shrink pb-2>
                                <div class="headline primary lighten-5 text-xs-center">{{ item.catalogNum }}</div>
                            </v-flex>
                        </v-layout>
                    </v-img>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-layout row>
                            <v-flex xs-12 text-xs-center subheading>{{ item.itemDesc }}</v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs4 body-2 >Class</v-flex>
                            <v-flex xs-8>{{ item.itemClass }}</v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs4 body-2 pt-1>Sell Rank</v-flex>
                            <v-flex xs8 text-xs-left pt-1>
                                <v-layout>
                                    <v-flex text-xs-center>
                                        <v-icon mediam v-show="item.sellingRank=='NEW'">fiber_new</v-icon>
                                    </v-flex>
                                </v-layout>
                                <v-rating
                                v-model="item.sellingRankNum"
                                color="yellow darken-3"
                                background-color="grey darken-1"
                                empty-icon="$vuetify.icons.ratingFull"
                                half-increments
                                hover
                                small
                                :dense="true"
                                :readonly="true"
                                ></v-rating>
                            </v-flex>
                        </v-layout>
                        <!-- // 20251212, stop show price after move to SAP 
                        <v-layout row>
                            <v-flex xs4 body-2 pt-1>Product Page</v-flex>
                            <v-flex xs8 text-xs-left py-1>
                                <v-layout v-for="(doc, idx) in item.productUrlList" :key="idx">
                                    <v-flex xs12 v-if="doc.url != ''">
                                        <a :href="doc.url" v-if="doc.urlName && doc.urlName.trim().length > 0" :class="doc.url?'' : 'red--text'" target="_blank">
                                            {{doc.name}}</a>
                                    </v-flex>
                                </v-layout>   
                                
                            </v-flex>
                        </v-layout> -->
                        <!-- <v-layout row>
                            <v-flex xs4 body-2 pt-1>Brochure</v-flex>
                            <v-flex xs8 text-xs-left py-1>
                                <v-layout v-for="(doc, idx) in item.brochureList" :key="idx">
                                    <v-flex xs12 v-if="doc.url != ''">
                                        <a :href="doc.url" v-if="doc.urlName && doc.urlName.trim().length > 0" :class="doc.url?'' : 'red--text'" target="_blank">
                                            {{doc.name}}</a>
                                        (page {{doc.atPage}})
                                    </v-flex>
                                </v-layout>   
                                
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs4 body-2 pt-1>IFU</v-flex>
                            <v-flex xs8 text-xs-left py-1>
                                <v-layout v-for="(doc, idx) in item.ifuList" :key="idx">
                                    <v-flex xs4 v-if="doc.url != ''">
                                        <a :href="doc.url" v-if="doc.urlName && doc.urlName.trim().length > 0" :class="doc.url?'' : 'red--text'" target="_blank">
                                            IFU</a>
                                    </v-flex>
                                </v-layout>   
                                
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs4 body-2 pt-1>MEMO</v-flex>
                            <v-flex xs8 text-xs-left py-1>
                                <v-layout v-for="(doc, idx) in item.memoList" :key="idx">
                                    <v-flex xs4 v-if="doc.url != ''">
                                        <a :href="doc.url" v-if="doc.urlName && doc.urlName.trim().length > 0" :class="doc.url?'' : 'red--text'" target="_blank">
                                            MEMO</a>
                                    </v-flex>
                                </v-layout>   
                                
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs4 body-2 pt-1>SDS</v-flex>
                            <v-flex xs8 text-xs-left py-1>
                                <v-layout v-for="(doc, idx) in item.sdsList" :key="idx">
                                    <v-flex xs4 v-if="doc.url != ''">
                                        <a :href="doc.url" v-if="doc.urlName && doc.urlName.trim().length > 0" :class="doc.url?'' : 'red--text'" target="_blank">
                                            SDS</a>
                                    </v-flex>
                                </v-layout>   
                                
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs4 body-2 pt-1>Price List</v-flex>
                            <v-flex xs8 text-xs-left py-1>
                                <v-layout v-for="(doc, idx) in item.priceList" :key="idx">
                                    <v-flex xs12 v-if="doc.url != ''">
                                        <a :href="doc.url" v-if="doc.urlName && doc.urlName.trim().length > 0" :class="doc.url?'' : 'red--text'" target="_blank">
                                            {{doc.name}}</a>
                                        (page {{doc.atPage}})
                                    </v-flex>
                                </v-layout>   
                                
                            </v-flex>
                        </v-layout> -->
                        <v-divider></v-divider>
                        <v-layout>
                            <v-flex xs12>
                                <table style="width:100%;">
                                    <thead>
                                        <th>Price</th>
                                        <th>Unit</th>
                                        <th>Qty. Range</th>
                                    </thead>
                                    <tbody>
                                        <tr v-for="itemPrice in item.prices" :key="itemPrice.itemPriceId">
                                            <td class="text-xs-center">{{itemPrice.uofmPrice | toCurrency}}</td>
                                            <td class="text-xs-center"><span>{{itemPrice.uofm}}</span></td>
                                            <td class="text-xs-center">{{itemPrice.fromQty}} - {{itemPrice.toQty == '999999999999'?'any' : itemPrice.toQty}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </v-flex>
                        </v-layout>
                    </v-card-text>

                </v-card>
            </v-flex>
        </v-layout>

        <!-- {{items}} -->
    </div>
</template>
<script>
// import _ from "lodash"
import ctlItemAdvancedSearchFilter from '@/components/ctlItemAdvancedSearchFilter'
import { mapActions } from 'vuex'

export default {
    props: ['items'],
    components: {
        'ctlItemAdvancedSearchFilter':ctlItemAdvancedSearchFilter
    },
    data () {
        return {
        }
    },
    computed: {
    },
    methods: {
        onPicked(itemPicked) {
            this.$emit('onItemPicked', itemPicked)
        },
    },
    watch: {
    }
}
</script>

